// 一级组织路由key
export const AICopilot_ROUTE_NAME = 'aiCopilot';
export const ORG_SETTING_PAGE_TYPE = 'orgSetting';
export const ENTERPRISE_SETTING_PAGE_TYPE = 'enterpriseSetting';
export const RESOURCE_CENTER_PAGE_TYPE = 'resourceCenter';
export const ORG_ISSUE_SETTING_ROUTE_NAME = 'orgSettingIssues';
export const ENTERPRISE_ISSUE_SETTING_ROUTE_NAME = 'enterpriseSettingIssues';
export const ENTERPRISE_MILESTONE_SETTING_ROUTE_NAME = 'enterpriseSettingMilestone';
export const ENTERPRISE_MEMBER_SETTING_ROUTE_NAME = 'enterpriseSettingMember';
export const ENTERPRISE_WEBHOOK_SETTING_ROUTE_NAME = 'enterpriseSettingWebhook';
export const ENTERPRISE_DEFAULT_SETTING = 'enterpriseSettingDefault';
